import "./Header.scss";

import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";

import { Breakpoint } from "react-socks";
import { myBagToggle } from "../../redux/slices/myBagToggleSlice";
import useGetUser from "../../hooks/useGetUser";
import INPUT from "../Master/INPUT";
import {
  ADDRESS_LINK,
  BAG_IC,
  cart_icon,
  CIRCLE_CLOSE_IC,
  CLOSE_BLACK_IC,
  CLOSE_IC,
  close_square_icon,
  dagacontactus_icon,
  // DGlogo,
  instagram,
  LIKE__IC,
  locationIcon,
  MENU_IC,
  menu_icon,
  MOBILE_NUMBER,
  PERSON_IC,
  SEARCH_IC,
  search_icon,
  userIcon,
  wishlist_icon,
  DagaBengaluruLogo,
  ARROW_FORWARD_BLACK_IC,
  ARROW_BACK_BLACK_IC,
} from "../../assets";
import { useGetHeaderCategoriesDataQuery } from "../../redux/slices/homeSlice";

function Header({
  isRetailerPage,
  sidebarToggle,
  setSidebarToggle,
  headerLabelsData,
}) {
  const [isVisible, setIsVisible] = useState(true);
  const [searchToggle, setSearchToggle] = useState(false);
  const location = window.location;
  const dispatch = useDispatch();
  const user = useGetUser();
  const params = useParams();

  const [searchProductsVal, setSearchProductsVal] = useState(
    location?.pathname?.split("/")[1] === "search"
      ? location?.pathname?.split("/")[2]
      : ""
  );

  const wishlistData = useSelector((state) => state.wishlist.data);

  useEffect(() => {
    if (!location?.pathname.includes("search")) {
      setSearchProductsVal("");
    }
  }, [location.pathname]);
  const myBagData = useSelector((state) => state?.myBagData?.items);

  useEffect(() => {
    if (location.pathname === "/login") {
      setIsVisible(false);
      return;
    }
  }, [location]);
  useEffect(() => {
    function handleScroll() {
      if (location.pathname === "/login") {
        setIsVisible(false);
        return;
      }
      if (window.scrollY > 300) {
        setIsVisible(false);
      } else {
        setIsVisible(true);
      }
    }

    window.addEventListener("scroll", handleScroll);
    // Cleanup function to remove the event listener when the component unmounts
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [location]);

  const AccountIcon = () => {
    return (
      <Link
        to={`${user?.customer ? "/profile-details#your-account" : "/login"}`}
        className="material-symbols-outlined link"
      >
        <img src={PERSON_IC} alt="" className="w-9" />
      </Link>
    );
  };
  const FavouriteIcon = () => {
    return (
      <Link
        to="/favourites"
        className="material-symbols-outlined link relative"
      >
        <img src={LIKE__IC} alt="" className="w-8" />
        {wishlistData?.length !== 0 && (
          <div className="absolute -top-1 right-1.5 bg-primary w-[20px] h-[20px] text-center flex flex-col items-center justify-center rounded-full">
            <span className="text-white text-[14px]">
              {wishlistData?.length > 9 ? "9+" : wishlistData?.length}
            </span>
          </div>
        )}
      </Link>
    );
  };

  const navigate = useNavigate();
  const searchProductsHandle = (value) => {
    setSearchProductsVal(value);
  };

  const searchNavigationHandle = (e) => {
    if (e.key === "Enter") {
      if (
        e.key === "Enter" &&
        !location.pathname.includes("search") &&
        searchProductsVal === ""
      ) {
        return;
      }
      if (location.pathname.includes("search") && searchProductsVal === "") {
        navigate(`/search`);
      } else {
        navigate(`/search/${searchProductsVal}`);
      }
    }
  };

  const mobileSearchNavigationHandle = (e) => {
    if (e.key === "Enter") {
      if (
        e.key === "Enter" &&
        !location.pathname.includes("search") &&
        searchProductsVal === ""
      ) {
        return;
      }
      if (location.pathname.includes("search") && searchProductsVal === "") {
        navigate(`/search`);
        setSearchToggle(false);
        document.body.style.overflow = "auto";
        document.body.style.height = "auto";
      } else {
        navigate(`/search/${searchProductsVal}`);
        setSearchToggle(false);
        document.body.style.overflow = "auto";
        document.body.style.height = "auto";
      }
    }
  };

  const [showBrowse, setShowBrowse] = useState(false);

  // =========== CATEGORY API CALLING =============

  const {
    data: headerCategoriesData,
    isSuccess: headerCategoriesSuccess,
    isLoading: headerCategoriesLoading,
    isError: headerCategoriesIsError,
    error: headerCategoriesError,
  } = useGetHeaderCategoriesDataQuery();

  return (
    <>
      {/* ========================New header=================== */}
      <div>
        <DagaHeader
          user={user}
          searchProductsVal={searchProductsVal}
          searchProductsHandle={searchProductsHandle}
          searchNavigationHandle={searchNavigationHandle}
          data={headerCategoriesSuccess && headerCategoriesData[0]?.children}
        />
        <DagaHeaderMobile
          user={user}
          searchProductsVal={searchProductsVal}
          searchProductsHandle={searchProductsHandle}
          searchNavigationHandle={searchNavigationHandle}
          data={headerCategoriesSuccess && headerCategoriesData[0]?.children}
        />
      </div>
    </>
  );
}
export default Header;

const DagaHeader = ({
  user,
  searchProductsVal,
  searchProductsHandle,
  searchNavigationHandle,
  data,
}) => {
  const dispatch = useDispatch();
  const myBagData = useSelector((state) => state?.myBagData?.items);
  const wishlistData = useSelector((state) => state.wishlist.data);

  // console.log(myBagData)
  const [dropdownTop, setDropdownTop] = useState(0);
  const headerRef = useRef(null);

  useEffect(() => {
    const updateDropdownTop = () => {
      if (headerRef.current) {
        const rect = headerRef.current.getBoundingClientRect();
        setDropdownTop(rect.bottom + window.scrollY);
      }
    };

    updateDropdownTop();
    console.log(dropdownTop);
    window.addEventListener("scroll", updateDropdownTop);
    window.addEventListener("resize", updateDropdownTop);

    return () => {
      window.removeEventListener("scroll", updateDropdownTop);
      window.removeEventListener("resize", updateDropdownTop);
      console.log(dropdownTop);
    };
  }, []);
  // console.log(window.scrollY);
  // console.log(dropdownTop);

  return (
    <div className="hidden md:block whitespace-nowrap">
      {/* <div className="bg-primary hidden sm:flex justify-between px-4 py-1">
        <div className="flex flex-row gap-2 items-center">
          <div className="text-text_light lato-regular">
            <img src={dagacontactus_icon} className="h-45 w-5"></img>
          </div>
          <div className="text-text_light lato-regular">
            +91 {MOBILE_NUMBER}
          </div>
        </div>
        <div className="flex justify-between gap-[0.5em]">
          <div className="text-text_light lato-regular">Enter Pincode</div>
          <div className="text-text_medium opacity-65 lato-regular">
            to check delivery
          </div>
        </div>
      </div> */}
      <div className="bg-secondary grid grid-cols-[minmax(0,_1fr)_100px_minmax(0,_1fr)] pt-2">
        <div className="flex flex-col justify-between">
          <div className="p-2 px-4">
            <INPUT
              isNotValidate
              placeHolder={"Search ..."}
              className={"py-0 px-0 w-1/2  border-b lato-regular"}
              mainClass={"p-0 m-0 w-[200px] "}
              val={searchProductsVal}
              onChange={(s) => searchProductsHandle(s.target?.value)}
              onKeyDown={(e) => searchNavigationHandle(e)}
              rComp={
                <div className="me-1">
                  <img
                    src={search_icon}
                    alt=""
                    className="p-1 h-[30px] w-[30px]"
                  />
                </div>
              }
            />
          </div>
          <div ref={headerRef} className="relative">
            <div className="text-text_dark_2 flex justify-end items-end text-sm lg:text-base pe-3 lg:pe-5 ">
              <DagaLeftMegaMenuBlock
                dropdownTopLeft={dropdownTop}
                data={data}
              />
            </div>
          </div>
        </div>
        <div className=" pb-2">
          <div className="flex justify-around">
            <Link className="uppercase object-cover" to="/">
              <img
                src={DagaBengaluruLogo}
                alt="logo"
                className="h-[100px] w-[100px] object-contain"
              />
            </Link>
          </div>
        </div>
        <div className="flex flex-col justify-between">
          <div className="p-2 px-4 flex justify-end gap-6">
            <Link
              to={`${
                user?.customer ? "/profile-details#your-account" : "/login"
              }`}
              // to="/#coming-soon"
            >
              <img
                className="h-[30px] w-[30px] p-1 object-contain"
                src={userIcon}
                alt=""
              />
            </Link>
            {/* <button
              className="relative cursor-pointer"
              onClick={() => {
                dispatch(myBagToggle());
                document.body.style.overflow = "hidden";
                document.body.style.height = "100vh";
              }}
              // to="/#coming-soon"
            >
              <img
                className="h-[30px] w-[30px] p-1 object-contain"
                src={cart_icon}
                alt="Cart"
              />
              {myBagData?.length !== 0 && (
                <div className="absolute -top-1 -right-1 bg-primary w-[20px] h-[20px] text-center flex flex-col items-center justify-center rounded-full">
                  <span className="text-text_medium text-[14px] lato-regular">
                    {myBagData?.length > 9 ? "9+" : myBagData?.length}
                  </span>
                </div>
              )}
            </button> */}
            {/* <div className="relative">
              <Link to="/favourites">
                <img
                  className="h-[30px] w-[30px] p-1 object-contain"
                  src={wishlist_icon}
                  alt="Wishlist"
                />
                {wishlistData?.length !== 0 && (
                  <div className="absolute -top-1 -right-1 bg-primary w-[20px] h-[20px] text-center flex flex-col items-center justify-center rounded-full">
                    <span className="text-text_medium text-[14px] lato-regular">
                      {wishlistData?.length > 9 ? "9+" : wishlistData?.length}
                    </span>
                  </div>
                )}
              </Link>
            </div> */}
            <Link to={ADDRESS_LINK} target="_blank">
              <img
                className="h-[30px] w-[30px] p-1 object-contain"
                src={locationIcon}
                alt="Address"
              />
            </Link>
          </div>
          {/* <div className="text-text_dark_2 flex justify-start items-end gap-5 lg:gap-10 text-sm lg:text-base ps-6 lg:ps-10"> */}
          <div className="text-text_dark_2 flex justify-start items-end text-sm lg:text-base ps-3 lg:ps-5">
            <DagaRightMegaMenuBlock dropdownTopRight={dropdownTop} />
          </div>
        </div>
      </div>
    </div>
  );
};

const DagaLeftMegaMenuBlock = (props) => {
  const navigate = useNavigate();
  const [showBrowse, setShowBrowse] = useState(false);
  const [categoryData, setCategoryData] = useState([]);
  const [selectedCategories, setSelectedCategories] = useState([]);

  const sortCategories = (data) => {
    if (data) {
      return data
        ?.map((category) => ({
          ...category,
          sortOrder: parseInt(category.sortOrder, 10),
          children: sortCategories(category.children),
        }))
        .sort((a, b) => a.sortOrder - b.sortOrder);
    }
    return [];
  };

  useEffect(() => {
    if (props?.data) {
      const sortedData = sortCategories(props?.data);
      setCategoryData(sortedData);
    }
  }, [props?.data]);
  const [selectedIndex, setSelectedIndex] = useState(-1);
  const handleHover = (level, category) => {
    setSelectedIndex(level);
    const newSelected = [...selectedCategories];
    newSelected[level] = category;
    setSelectedCategories(newSelected.slice(0, level + 1));
  };

  useEffect(() => {
    const newSelected = [...selectedCategories];
    newSelected[3] = categoryData[3];
    setSelectedCategories(newSelected.slice(0, 3 + 1));
  }, [categoryData]);

  const handleNavigate = (category) => {
    navigate(
      category?.slug
        ? `/categories/${category.slug}`
        : `/categories/${category._id}`
    );
    setShowBrowse(false);
    setSelectedCategories([]);
  };

  return (
    <div className="flex items-center">
      <div
        onMouseEnter={() => setShowBrowse(true)}
        onMouseLeave={() => {
          setShowBrowse(false);
          setSelectedCategories([]);
        }}
        className="relative uppercase cormorant-medium text-xl group pb-2 z-9 px-[14px] lg:px-8"
      >
        <span className="cursor-pointer" onClick={() => navigate("/")}>
          Jewels
        </span>
        {showBrowse && (
          <div
            className={`bg-white absolute shadow-c_shadow items-start justify-start z-10 flex left-0 top-9 w-[800px]`}
          >
            {/* Main Categories */}
            <div className="relative w-fit flex flex-col bg-secondary min-w-52 ">
              {categoryData?.map((category, index) => (
                <div
                  key={index}
                  className={`cursor-pointer relative py-2 text-start me-4 w-full text-ellipsis overflow-hidden ${
                    selectedCategories[0]?._id === category._id
                      ? "title-container text-primary bg-white"
                      : ""
                  }`}
                  onMouseEnter={() => handleHover(0, category)}
                  onClick={() => handleNavigate(category)}
                >
                  <div className="w-full justify-between lato-regular text-base cursor-pointer flex items-center relative ps-4 py-2">
                    {category?.name?.en}
                    {category?.children?.length > 0 && (
                      <span className="ms-2 text-xs text-primary me-2">⟫</span>
                    )}
                  </div>
                </div>
              ))}
            </div>

            {/* Subcategories */}
            {selectedCategories?.map(
              (category, level) =>
                category?.children?.length > 0 && ( // Check if the category has children
                  <div
                    key={level}
                    className="cursor-pointer text-start justify-start text-base w-full sub_category_div bg-white min-w-fit h-full"
                  >
                    {(category?.children || [])?.map((subCategory, index) => (
                      <div
                        key={index}
                        className={`relative py-1 text-start justify-start flex me-4 text-ellipsis overflow-hidden ${
                          selectedCategories[level + 1]?._id === subCategory._id
                            ? "title-container text-primary underline underline-primary"
                            : ""
                        }`}
                        onMouseEnter={() => handleHover(level + 1, subCategory)}
                        onClick={() => handleNavigate(subCategory)}
                      >
                        <div className="flex lato-regular text-sm items-center relative ps-4 py-1">
                          {subCategory?.name?.en}
                          {subCategory?.children?.length > 0 && (
                            <span className="ms-2 text-xs text-primary">⟫</span>
                          )}
                        </div>
                      </div>
                    ))}
                  </div>
                )
            )}
          </div>
        )}
      </div>
      <Link
        className="uppercase cormorant-medium text-xl group pb-2 z-9 px-[14px] lg:px-8"
        to={`/`}
      >
        News/Events
      </Link>
    </div>
  );
};

const DagaRightMegaMenuBlock = (props) => {
  const megaMenuRightItems = {
    "Contact Us": [
      {
        title: "Contact Us",
        linkTo: "/contact-us",
        main_item: "",
      },
    ],
    "About-Us": [
      {
        title: "About Us",
        linkTo: "/aboutus",
        main_item: "",
      },
    ],
  };

  const [activeRightMenu, setActiveRightMenu] = useState(null);
  const [activeRightSubMenu, setActiveRightSubMenu] = useState(null);
  const [hoveredMainItem, setHoveredMainItem] = useState(null);

  const handleRightMenuHover = (menuItem) => {
    setActiveRightMenu(menuItem);
    // Automatically display the first category's submenu when the menu is hovered
    setActiveRightSubMenu(megaMenuRightItems[menuItem][0].main_item);
  };
  const handleMainItemHover = (mainItem) => {
    setHoveredMainItem(mainItem);
  };
  const handleMainItemLeave = () => {
    setHoveredMainItem(null);
  };

  return (
    <>
      {Object.keys(megaMenuRightItems)?.map((menuItem, index) => (
        <div
          key={index}
          onMouseEnter={() => {
            megaMenuRightItems[menuItem]?.find((item) => item.sub_items) &&
              handleRightMenuHover(menuItem);
          }}
          onMouseLeave={() => setActiveRightMenu(null)}
          className="group pb-2 z-9 px-[14px] lg:px-8"
        >
          {megaMenuRightItems[menuItem]?.map((category, index2) => (
            <Link
              key={index2}
              className="uppercase cormorant-medium text-xl"
              to={`${category.linkTo}`}
              onClick={() => setActiveRightMenu(null)}
            >
              {category.title}
            </Link>
          ))}
          <div
            className={`absolute left-0 w-[100vw] h-fit bg-text_light_2 text-black 
        opacity-0 pointer-events-none mt-2
        ${
          activeRightMenu === menuItem ? "opacity-100 pointer-events-auto" : ""
        }`}
            // style={{ top: `calc(${props.dropdownTopRight}px - ${window.scrollY}px )` }}
          >
            <div className="bg-primary w-full h-[1px]"></div>
            <div className="flex h-full">
              {/* Left side (20% width) for category names */}
              <div className="min-w-[15%] w-max">
                {megaMenuRightItems[menuItem]?.map((category) => (
                  <div
                    key={category.main_item}
                    onMouseEnter={() => {
                      setActiveRightSubMenu(category.main_item);
                      handleMainItemHover(category.main_item);
                    }}
                    onMouseLeave={handleMainItemLeave}
                    className={`cursor-pointer hover:bg-text_light z-9 ${
                      hoveredMainItem === category.main_item
                        ? "bg-text_light"
                        : ""
                    }`}
                  >
                    <div className=" text-text_dark_4 lato-semibold w-full text-base font-bold border-b-[1px] border-text_dark_3 py-3 pr-3 pl-2 hover:text-primary">
                      {category.main_item}
                    </div>
                  </div>
                ))}
              </div>

              {/* Right side (80% width) for sub-categories in 3 columns */}
              <div
                className={`w-full p-6 ${
                  hoveredMainItem === activeRightSubMenu ? "bg-text_light" : ""
                }`}
              >
                {activeRightSubMenu && (
                  <div className="flex flex-row gap-10">
                    {megaMenuRightItems[menuItem]
                      ?.find(
                        (category) => category.main_item === activeRightSubMenu
                      )
                      ?.sub_items?.map((subCat, index) => (
                        <div key={index} className="w-fit">
                          <div className="pb-4">
                            <Link
                              to=""
                              className="font-semibold mb-4 lato-medium"
                              onClick={() => setActiveRightMenu(null)}
                            >
                              {subCat.sub_item}
                            </Link>
                          </div>
                          <div className="flex flex-col space-y-1 pl-4">
                            {subCat?.types?.map((type, typeIndex) => (
                              <Link
                                key={typeIndex}
                                to=""
                                className=" flex flex-row px-1 pb-2 items-center gap-1"
                                onClick={() => setActiveRightMenu(null)}
                              >
                                <img
                                  className="h-[40px] w-[40px] p-1 object-contain"
                                  src={`${type.imgsrc}`}
                                  alt="Wishlist"
                                />
                                <span className="text-sm text-primary hover:underline lato-regular">
                                  {type.item_name}
                                </span>
                              </Link>
                            ))}
                          </div>
                        </div>
                      ))}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      ))}
    </>
  );
};

{
  /*--------------------------------------------|-DAGA MOBILE HEADER-|-----------------------------------------------------*/
}

const DagaHeaderMobile = ({
  user,
  searchProductsVal,
  searchProductsHandle,
  searchNavigationHandle,
  data,
}) => {
  const dispatch = useDispatch();

  const wishlistData = useSelector((state) => state.wishlist.data);
  const myBagData = useSelector((state) => state?.myBagData?.items);
  const navigate = useNavigate();

  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const [showBrowse, setShowBrowse] = useState(false);
  const [menuStack, setMenuStack] = useState([]); // Stack to keep track of navigation path

  const sortCategories = (data) => {
    if (data) {
      return data
        ?.map((category) => ({
          ...category,
          sortOrder: parseInt(category.sortOrder, 10), // Convert sortOrder to a number
          children: sortCategories(category.children), // Recursively sort children
        }))
        .sort((a, b) => a.sortOrder - b.sortOrder); // Sort current level by sortOrder
    }
  };

  useEffect(() => {
    if (data) {
      const sorted = sortCategories(data);
      setMenuStack([{ title: "Main Menu", items: sorted }]);
    }
  }, [data, showBrowse]);

  const handleCategoryClick = (category) => {
    if (category?.children && category?.children?.length > 0) {
      setMenuStack((prev) => [
        ...prev,
        { title: category.name.en, items: category.children },
      ]);
    }
  };

  const handleBackClick = () => {
    if (menuStack?.length > 1) {
      setMenuStack((prev) => prev.slice(0, -1)); // Go back one level
    } else {
      setShowBrowse(false); // Go back to the main menu
    }
  };

  const handleBrowseClick = () => {
    setShowBrowse(true);
  };

  const currentMenu = menuStack[menuStack?.length - 1]; // Current menu level

  return (
    <div className="relative md:hidden">
      <div className="bg-secondary flex flex-col gap-4 grid-rows-2 px-4 pt-4 pb-7 max-w-[767px]">
        <div className="grid grid-cols-[minmax(0,_1fr)_55px_minmax(0,_1fr)]">
          <div className="flex">
            <button onClick={toggleSidebar} className="flex items-center">
              <img src={menu_icon} alt="" className="h-8 w-8" />
            </button>
          </div>
          <div className="">
            <Link className="uppercase object-cover" to="/">
              <img
                src={DagaBengaluruLogo}
                alt="menu"
                className="h-[65px] w-[55px]"
              />
            </Link>
          </div>
          <div className="flex gap-4 justify-end items-center">
            <Link to={ADDRESS_LINK} target="_blank">
              <img
                className="h-[30px] w-[30px] p-1 object-contain"
                src={locationIcon}
                alt="Address"
              />
            </Link>
            <Link
              to={`${
                user?.customer ? "/profile-details#your-account" : "/login"
              }`}
              // to="/#coming-soon"
            >
              <img src={userIcon} alt="" className="h-7 w-7" />
            </Link>
            {/* <button
              // to="/#coming-soon"
              className="relative"
              onClick={() => {
                dispatch(myBagToggle());
                document.body.style.overflow = "hidden";
                document.body.style.height = "100vh";
              }}
            >
              <img
                className="h-[35px] w-[35px] p-1 object-contain"
                src={cart_icon}
                alt="Cart"
              />
              {myBagData?.length !== 0 && (
                <div className="absolute -top-1 -right-1 bg-primary w-[20px] h-[20px] text-center flex flex-col items-center justify-center rounded-full">
                  <span className="text-text_medium text-[14px] lato-regular">
                    {myBagData?.length > 9 ? "9+" : myBagData?.length}
                  </span>
                </div>
              )}
            </button> */}
          </div>
        </div>
        <div className="relative flex justify-center items-center w-full -mb-3 h-fit">
          <INPUT
            isNotValidate
            placeHolder={"Search ..."}
            className={"py-0 px-0 w-full  border-b lato-regular"}
            mainClass={"p-0 m-0 w-[200px] "}
            val={searchProductsVal}
            onChange={(s) => searchProductsHandle(s.target?.value)}
            onKeyDown={(e) => searchNavigationHandle(e)}
            lComp={
              <div className="me-1">
                <img
                  src={search_icon}
                  alt=""
                  className="p-1 h-[30px] w-[30px]"
                />
              </div>
            }
          />
        </div>
      </div>

      <div
        className={`fixed top-0 left-0 h-full w-64 bg-secondary transform ${
          isSidebarOpen ? "translate-x-0" : "-translate-x-full"
        } transition-transform duration-300 ease-in-out z-999999`}
      >
        <div className="w-full flex justify-end p-2">
          <button onClick={toggleSidebar} className="text-primary">
            <img src={close_square_icon} alt="" className="h-9 w-9" />
          </button>
        </div>
        {!showBrowse ? (
          <nav className="mt-4 z-999999 px-2 ">
            <ul className="space-y-4">
              <li className="border-b-[0.5px] border-b-text_dark_4">
                <Link
                  to="/aboutus"
                  className="block px-2 pb-2 text-primary cormorant-bold"
                  onClick={toggleSidebar}
                >
                  About Us
                </Link>
              </li>
              <li className="border-b-[0.5px] border-b-text_dark_4">
                <Link
                  to="/#coming-soon"
                  className="block px-2 pb-2 text-primary cormorant-bold"
                  onClick={toggleSidebar}
                >
                  News/Events
                </Link>
              </li>
              <li className="w-full border-b-[0.5px] border-b-text_dark_4 flex items-center justify-between">
                <span
                  className="block px-2 pb-2 text-primary cormorant-bold"
                  onClick={handleBrowseClick}
                >
                  Jewels
                </span>
                <div
                  onClick={handleBrowseClick}
                  className="text-sm rounded-full bg-gray w-[20px] h-[20px] flex items-center justify-center cursor-pointer"
                >
                  <img src={ARROW_FORWARD_BLACK_IC} alt="" className="m-auto" />
                </div>
              </li>
              <li className="border-b-[0.5px] border-b-text_dark_4">
                <Link
                  to="/contact-us"
                  className="block px-2 pb-2 text-primary cormorant-bold"
                  onClick={toggleSidebar}
                >
                  Contact Us
                </Link>
              </li>
              {/* <li className="border-b border-b-text_dark_4">
                <div className="relative pb-2">
                  <div className="flex flex-row gap-3 items-center">
                    <Link to="/favourites">
                      <img
                        className="h-[30px] w-[30px] p-1 object-contain "
                        src={wishlist_icon}
                        alt="Wishlist"
                      />
                      {wishlistData?.length !== 0 && (
                        <div className="absolute -top-1 left-4 bg-primary w-[20px] h-[20px] text-center flex flex-row items-center justify-center rounded-full">
                          <span className="text-text_medium text-[14px]">
                            {wishlistData?.length > 9
                              ? "9+"
                              : wishlistData?.length}
                          </span>
                        </div>
                      )}
                    </Link>
                    <span className="border-l border-l-primary pl-3 text-primary cormorant-bold">
                      Wishlist
                    </span>
                  </div>
                </div>
              </li> */}
            </ul>
          </nav>
        ) : (
          <div className="w-full flex flex-col h-full">
            {/* Back Button and Current Category Title */}
            <div
              onClick={handleBackClick}
              className="w-full flex items-center px-4 my-2 cursor-pointer"
            >
              <div className="text-primary text-xl">
                <img src={ARROW_BACK_BLACK_IC} alt="" />
              </div>
              <span className="ms-2 text-xl text-primary">
                {menuStack?.length > 1 ? currentMenu?.title : "Jewels"}
              </span>
            </div>

            <div className="sub_cat_div_mobile w-full flex flex-col grow pb-20 overflow-y-auto overflow-x-hidden">
              {currentMenu?.items?.map((item) => (
                <div
                  key={item._id}
                  className="w-full flex items-center justify-between py-2 px-4 mb-2"
                >
                  <div
                    onClick={() => {
                      navigate(
                        item?.slug
                          ? `/categories/${item?.slug}`
                          : `/categories/${item?._id}`
                      );
                      toggleSidebar();
                      setMenuStack([]);
                      setShowBrowse(false);
                      document.body.style.overflow = "auto";
                      document.body.style.height = "auto";
                    }}
                    className="text-base hover:text-primary cursor-pointer lato-regular text-sm"
                  >
                    {item.name.en}
                  </div>
                  {item?.children && item?.children?.length > 0 && (
                    <div
                      onClick={() => handleCategoryClick(item)}
                      className="text-sm rounded-full bg-gray w-[20px] h-[20px] flex items-center justify-center cursor-pointer"
                    >
                      <img
                        src={ARROW_FORWARD_BLACK_IC}
                        alt=""
                        className="m-auto"
                      />
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        )}
      </div>

      {isSidebarOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-5 z-99999"
          onClick={toggleSidebar}
        ></div>
      )}
    </div>
  );
};
